/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "secure_profile": {
        "nested": {
          "common": {
            "nested": {
              "TargetType": {
                "values": {
                  "REGISTER_UNIT": 1,
                  "REGISTER_MERCHANT": 2,
                  "REGISTER_PAYMENT": 3,
                  "CAPITAL_CUSTOMER": 4,
                  "PROMPT_VARIABLE_DYNAMIC": 5,
                  "MARKETPLACE_SUB_SELLER": 6,
                  "CAPITAL_BUSINESS_APPLICATION": 7
                }
              },
              "RequestState": {
                "values": {
                  "PENDING_COMPLETION": 1,
                  "PENDING_REVIEW": 2,
                  "PENDING_FURTHER_COMPLETION": 3,
                  "REVIEWED_AND_ACCEPTED": 4,
                  "REVIEWED_AND_DEACTIVATED": 5,
                  "REVIEWED_AND_FROZEN": 6,
                  "REVIEWED": 7,
                  "EXPIRED": 8,
                  "CLOSED": 9
                }
              },
              "RequestType": {
                "values": {
                  "SALES": 1,
                  "RISK": 2,
                  "CAPITAL_BUSINESS_FINANCING": 3,
                  "CREDIT_RISK": 4,
                  "COMPLIANCE": 5,
                  "DEFAULT": 6,
                  "CAPITAL_BUSINESS_COMPLIANCE": 7,
                  "CAPITAL_BUSINESS_RISK": 8,
                  "CAPITAL_TXD": 9,
                  "BUSINESS_BANKING": 10,
                  "CAPITAL_PPP": 11,
                  "CAPITAL_PPP_FORGIVENESS": 12,
                  "CBD_COMPLIANCE": 13,
                  "CBD_CREDIT_RISK": 14,
                  "REASSESSMENT": 15,
                  "SELF_PAY_POLICY_WARNING": 16,
                  "CAPITAL_SBA": 17,
                  "CAPITAL_PPP_FORGIVENESS_AUDIT": 18,
                  "CAPITAL_BUSINESS_PAYROLL_VERIFICATION": 19,
                  "COMPLIANCE_CBD_HEALTH_WARNING": 20,
                  "CAPITAL_CUSTOMER_INFORMATION": 21,
                  "SELLER_NAME_CHANGE": 22,
                  "CANNABIS_ONBOARDING_COMPLIANCE": 23,
                  "SAVINGS_CUSTOMER_INFORMATION": 24,
                  "COMPLIANCE_MERCHANT_URL": 25,
                  "PAYMENT_METHOD_ENROLLMENT": 26,
                  "COMPLIANCE_NDA": 27,
                  "COMPLIANCE_IDV": 28,
                  "COMPLIANCE_JP_ONBOARD": 29,
                  "CREDIT_RISK_OPTIONAL": 30,
                  "DISPUTES": 31,
                  "COMPLIANCE_SANCTIONS": 32,
                  "JCB_ONBOARDING": 33,
                  "EMONEY_ONBOARDING": 34,
                  "UK_IDV_REMEDIATION": 35,
                  "BANKING_IDV": 36,
                  "CREDIT_RISK_UNDERWRITING": 37,
                  "COMPLIANCE_FCST_858": 38,
                  "COMPLIANCE_ONBOARD": 39,
                  "CAPABILITY_MANAGEMENT_ANY": 40,
                  "CAPABILITY_MANAGEMENT_DGFT": 41,
                  "CAPITAL_SBI": 42,
                  "COMPLIANCE_IRF_BACKFILL": 43,
                  "GROSS_SETTLEMENT_FEE_BANK_ACCOUNTS": 44,
                  "COMPLIANCE_SANCTIONS_EDD": 45,
                  "CA_KYC_REMEDIATION": 46,
                  "RISK_BUSDOCIDV": 47,
                  "COMPLIANCE_NON_FREEZE": 48,
                  "CA_KYB_REMEDIATION": 49,
                  "DEACTIVATION_APPEAL": 50,
                  "NMI_CAPABILITY_MANAGEMENT_DGFT": 51,
                  "COMPLIANCE_JCB_IRF_BACKFILL": 52,
                  "CREDIT_CARD_REVIEW": 53,
                  "CA_ONGOING_MONITORING": 54,
                  "IDDASH_INDIVIDUAL_NAME_CHANGE": 55,
                  "CAPABILITY_MANAGEMENT_JCB": 56,
                  "ISSUING_DEBIT_CARD_DISPUTES": 57,
                  "COMPLIANCE_TEMPORAL": 58,
                  "ISSUING_CREDIT_CARD_DISPUTES": 59,
                  "IDDASH_INDIVIDUAL_EXPIRED_ID_IDV": 60,
                  "CAPABILITY_MANAGEMENT_EBT": 61
                }
              },
              "Target": {
                "fields": {
                  "targetType": {
                    "type": ".squareup.secure_profile.common.TargetType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.secure_profile?.nested?.common?.nested?.TargetType && !$root.nested?.squareup?.nested?.secure_profile?.nested?.common?.nested?.RequestState && !$root.nested?.squareup?.nested?.secure_profile?.nested?.common?.nested?.RequestType && !$root.nested?.squareup?.nested?.secure_profile?.nested?.common?.nested?.Target) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TargetType @ squareup/secure_profile/common.proto at 24:1
 */
export const TargetType = $root.lookupEnum('squareup.secure_profile.common.TargetType').values;
/**
 * SOURCE RequestState @ squareup/secure_profile/common.proto at 51:1
 */
export const RequestState = $root.lookupEnum('squareup.secure_profile.common.RequestState').values;
/**
 * For common RequestType queries (like last used), see http://go/secure_profile_snowflake
 *
 * SOURCE RequestType @ squareup/secure_profile/common.proto at 64:1
 */
export const RequestType = $root.lookupEnum('squareup.secure_profile.common.RequestType').values;
/**
 * SOURCE Target @ squareup/secure_profile/common.proto at 183:1
 */
export const Target = $root.lookupType('squareup.secure_profile.common.Target');
fixType(Target, {
  targetType: {
    required: true
  },
  token: {
    required: true
  }
});
Builder.createAndAttachToType(Target);